import { Button, UIHeading1, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IReviewsEmptySnippetProps {
  elementId?: string;
  onWriteButtonClick: VoidFunction;
}

export function ReviewsEmptySnippet({ elementId, onWriteButtonClick }: IReviewsEmptySnippetProps) {
  return (
    <div className={styles['container']} id={elementId}>
      <div className={styles['title']}>
        <UIHeading1>Напишите отзыв</UIHeading1>
      </div>
      <div className={styles['subtitle']}>
        <UIText2>Помогите другим определиться с выбором</UIText2>
      </div>
      <Button theme="fill_primary" size="M" onClick={onWriteButtonClick}>
        Написать отзыв
      </Button>
    </div>
  );
}
